import React, { useMemo } from "react";
import Collapse from "../../../Collapse";
import styles from "./styles.module.css";
import HistoryCollapseHeader from "./HistoryCollapseHeader";
import HistoryExpandContent from "./HistoryExpandContent";
import PurposeShortDetails from "./PurposeShortDetails";
import DownloadContainer from "./DownloadContainer";
import NoHistory from "./NoHistory";
const ConsentHistory = ({ history, info, digitalIdentity }) => {
  const sortedHistory = useMemo(() => {
    return history?.sort((a, b) => new Date(b.valid_to) - new Date(a.valid_to));
  }, [history]);

  const items = sortedHistory?.map((item, index) => ({
    key: `item-${index + 1}`,
    header: (
      <HistoryCollapseHeader
        status={item?.status}
        lastChannel={item?.last_update_channel}
        dateTime={item?.last_status_change_datetime}
      />
    ),
    content: <HistoryExpandContent {...item} digitalIdentity={digitalIdentity} />,
  }));
  return (
    <div className={styles["info-container"]}>
      <PurposeShortDetails
        purpose={info?.global_purpose}
        current={info?.status}
        legalbasis={info?.initial_legal_basis}
      />
      {items?.length ? (
        <>
          <DownloadContainer
            digitalIdentity={digitalIdentity}
            info={info}
            history={sortedHistory}
          />
          <Collapse
            items={items}
            containerStyles={styles["collapse-container"]}
            itemStyles={styles["collapse-item"]}
            headerStyles={styles["collapse-header"]}
          />
        </>
      ) : (
        <NoHistory />
      )}
    </div>
  );
};

export default ConsentHistory;
